import { FC } from 'react';
import { IOuter } from './LightUploadingFile.types';

export const LightUploadingFile: FC<IOuter> = () => null;
